document.addEventListener("DOMContentLoaded", function () {

  const card = document.getElementById("njContactCard");
  const fab = document.getElementById("njContactFab");
  const closeBtn = document.getElementById("njContactClose");

  if (!card) return;

  // Hide floating button initially
  if (fab) {
    fab.style.display = "none";
  }

  // Close card
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {

      card.classList.add("closed");

      setTimeout(function () {

        if (fab) {
          fab.style.display = "flex";
        }

      }, 300);

    });
  }

  // Reopen card
  if (fab) {

    fab.addEventListener("click", function () {

      fab.style.display = "none";

      card.classList.remove("closed");

    });

  }

});